<template lang="pug">
v-container.fill-height.align-start.flex-column(fluid v-resize="onResize")
    AddBoarderDialog(v-if="showAddBoarderDialog" :show="showAddBoarderDialog" @close="onAddBoarderDialogClose" @newBoarderCrated="onNewBoarderCrated")
    OptOutDialog(v-if="showOptOutStepper" :show="showOptOutStepper" :boarder-list="currentSelection" @close="onOptOutStepperClose")
    OptInDialog(v-if="showOptInDialog" :show="showOptInDialog" :boarder-list="currentSelection" @close="onOptInDialogClose")
    BoarderDetailDialog(v-if="showBoarderDetailDialog" :show="showBoarderDetailDialog" :boarder="currentBoarder" @close="onBoarderDialogClose")
    BoarderArchiveDialog(v-if="showArchiveDialog" :show="showArchiveDialog" :boarder-list="currentSelection" @close="onArchiveDialogClose")
    MoveBoarderToGroupDialog(v-if="showMoveToGroupDialog" :show="showMoveToGroupDialog" :boarder-list="currentSelection" @close="onMoveToGroupDialogClose")
    SendEmailDialog(v-if="showSendEmailDialog" :show="showSendEmailDialog" :boarder-list="currentSelection" @close="onSendEmailDialogClose" @send="onSendEmailDialogClose")
    ImportAttendanceDialog(v-if="showImportAttendanceDialog" :show="showImportAttendanceDialog" @close="onImportAttendanceDialogClose")
    QrCodeDialog(v-if="showQrPrintDialog" :show="showQrPrintDialog" :selectedBoarderList="currentSelection" @close="onQrCodeDialogClose")

    template(v-if="boarderData")
        v-container.pa-0
            v-toolbar(dense flat)
                v-sheet(:max-width="cardWidth")
                    v-slide-group.v-slide-group(multiple show-arrows prev-icon="far fa-arrow-left" next-icon="far fa-arrow-right" )
                        v-slide-item
                            v-btn(small text @click="onAddBoarderButtonClick")
                                v-icon fas fa-user-plus
                                span.ma-2 {{ $t('boarderManagementPage.addBoarderButtonLabel') }}
                        v-slide-item
                            v-btn(small text  @click="onSendEmailButtonClick" :disabled="isSendEmailButtonDisabled")
                                v-icon fas fa-envelope
                                span.ma-2 {{ $t('sendEmailDialog.createNewMessageLabel') }} {{ selectionCount }}
                        v-slide-item
                            v-btn(small text :disabled="isOptOutButtonDisabled" @click="onOptOutButtonClick")
                                v-icon fas fa-user-alt-slash
                                span.ma-2 {{ $t('boarderManagementPage.optOutButtonLabel') }} {{ selectionCount }}
                        v-slide-item
                            v-btn(small text :disabled="isOptOutButtonDisabled" @click="onOptInButtonClick")
                                v-icon fas fa-user-check
                                span.ma-2 {{ $t('boarderManagementPage.optInButtonLabel') }} {{ selectionCount }}
                        v-slide-item
                            v-btn(small text :disabled="isArchiveButtonDisabled" @click="onArchiveButtonClick")
                                v-icon fas fa-user-times
                                span.ma-2 {{ $t('boarderManagementPage.archiveButtonLabel') }} {{ selectionCount }}
                        v-slide-item
                            v-btn(small text :disabled="isArchiveButtonDisabled" @click="onMoveToGroupButtonClick")
                                v-icon fas fa-house-return
                                span.ma-2 {{ $t('boarderManagementPage.moveToGroupButtonLabel') }} {{ selectionCount }}
                        v-slide-item
                            v-btn(small text :disabled="isQrDownloadButtonDisabled" :loading="qrDownloadInProgress" @click="onPrintQrCodesButtonClick")
                                v-icon fas fa-print
                                span.ma-2 {{ $t('boarderManagementPage.downloadQrFileButtonLabel') }} {{ selectionCount }}
                        v-slide-item
                            v-btn(small text @click="onImportAttendanceButtonClick")
                                v-icon fas fa-clipboard-user
                                span.ma-2 {{ $t('boarderManagementPage.importAttendanceButtonLabel') }}

        v-container.pa-0.flex-shrink-0.flex-grow-1(ref="agGrid")
            AgGridVue.mt-2.ag-theme-balham(
                style="width: 100%; height: 100%; min-height: 500px"
                :gridOptions="gridOptions"
                :columnDefs="columnDefs"
                :rowData="rowData"
                :localeTextFunc="localeTextFunc"
                @grid-ready="onGridReady"
                @selection-changed="onSelectionChange"
                @row-double-clicked="onBoarderDetailEvent"
                @cell-context-menu="onBoarderDetailEvent"
            )
    v-skeleton-loader.sloader(v-else type="paragraph@7")

</template>

<script lang="ts">
import Vue from 'vue'
import 'ag-grid-enterprise'
import {AgGridVue} from 'ag-grid-vue'
import {
  ColDef,
  ColumnApi,
  GridApi,
  GridOptions,
  RowClickedEvent,
  RowNode,
  ValueFormatterParams,
  ValueGetterParams
} from 'ag-grid-community'
import {BOARDER_FETCH_LIST} from '@/store/action-types'
import {BoarderResponse} from '@/types/service-response'
import AddBoarderDialog from '@/components/boarder-management/AddBoarderDialog.vue'
import OptOutDialog from '@/components/boarder-management/OptOutDialog.vue'
import OptInDialog from '@/components/boarder-management/OptInDialog.vue'
import BoarderDetailDialog from '@/components/boarder-management/BoarderDetailDialog.vue'
import BoarderArchiveDialog from '@/components/boarder-management/BoarderArchiveDialog.vue'
import MoveBoarderToGroupDialog from '@/components/boarder-management/MoveBoarderToGroupDialog.vue'
import {Component} from "vue-property-decorator";
import SendEmailDialog from "@/components/boarder-management/SendEmailDialog.vue";
import ImportAttendanceDialog from '@/components/boarder-management/ImportAttendanceDialog.vue'
import QrCodeDialog from "@/components/boarder-management/QrCodeDialog.vue";

let gridApi: GridApi | null | undefined
let columnApi: ColumnApi | null | undefined

@Component({
  components: {
    AddBoarderDialog,
    OptOutDialog,
    OptInDialog,
    BoarderDetailDialog,
    BoarderArchiveDialog,
    MoveBoarderToGroupDialog,
    AgGridVue,
    SendEmailDialog,
    ImportAttendanceDialog,
    QrCodeDialog
  }
})
export default class BoarderManagementPage extends Vue {

  $refs!: {
    agGrid: HTMLElement
  }

  private gridOptions: GridOptions = {}
  private columnDefs: ColDef[] = []
  private boarderData: BoarderResponse[] | null = null
  private rowData: BoarderResponse[] = []
  private currentBoarder: BoarderResponse | null = null
  private currentSelection: BoarderResponse[] = []
  private showAddBoarderDialog: boolean = false
  private showOptOutStepper: boolean = false
  private showOptInDialog: boolean = false
  private showBoarderDetailDialog: boolean = false
  private showArchiveDialog: boolean = false
  private showMoveToGroupDialog: boolean = false
  private showSendEmailDialog: boolean = false
  private qrDownloadInProgress: boolean = false
  private localeTextFunc: Function | null = null
  private cardWidth: number | null = null
  private showImportAttendanceDialog: boolean = false
  private showQrPrintDialog: boolean = false

  get isOptOutButtonDisabled(): boolean {
    return this.currentSelection.length === 0
  }

  get isSendEmailButtonDisabled(): boolean {
    return this.currentSelection.length === 0
  }

  get isArchiveButtonDisabled(): boolean {
    return this.currentSelection.length === 0
  }

  get isQrDownloadButtonDisabled(): boolean {
    return this.currentSelection.length === 0
  }

  get selectionCount(): string {
    const count = this.currentSelection.length

    if (count > 0) {
      return `(${count})`
    }

    return ''
  }

  async fetchData(): Promise<any> {
    this.boarderData = await this.$store.dispatch(BOARDER_FETCH_LIST)

    this.rowData = this.boarderData!
  }

  createColDefs(): ColDef[] {
    let hideDetails = false

    if (
      screen.orientation.type.includes('portrait')
      && ['xs', 'sm'].includes(this.$vuetify.breakpoint.name as string)
    ) {
      hideDetails = true
    }

    return [
      {
        flex: 2,
        minWidth: 221,
        headerName: this.$t('boarderManagementPage.nameColumnLabel').toString(),
        suppressMenu: hideDetails,
        filterParams: {
          debounceMs: 250,
          textCustomComparator: (filter: string, value: string, filterText: string) => {
            const filterTextNormalizeLowerCase = filterText.normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '').toLowerCase();
            const valueNormalizeLowerCase = value.toString().normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '').toLowerCase();


            switch (filter) {
              case 'contains':
                let passed = true
                filterTextNormalizeLowerCase.split(' ').forEach((filterWord: string) => {
                  if (valueNormalizeLowerCase.indexOf(filterWord) < 0) {
                    passed = false;
                  }
                })
                return passed;
              default:
                return false;
            }
          }
        },

        valueGetter(params: ValueGetterParams): string {
          return `${params.data.person.familyName} ${params.data.person.firstName}`
        }
      },
      {
        colId: 'customers',
        flex: 2,
        minWidth: 225,
        field: 'customer.name',
        headerName: this.$t('boarderManagementPage.customerColumnLabel').toString(),
        hide: hideDetails
      },
      {
        flex: 1,
        minWidth: 98,
        headerName: this.$t('boarderManagementPage.groupColumnLabel').toString(),
        suppressMenu: hideDetails,

        valueGetter(params: ValueGetterParams): string {
          return params.data.boarderGroupCollection
            .map((bg: any) => bg.name)
            .join(', ')
        }
      },
      {
        flex: 2,
        minWidth: 90,
        headerName: this.$t('boarderManagementPage.bankIdentificationCodeColumnLabel').toString(),
        suppressMenu: hideDetails,
        field: 'bankIdentificationCode',

        valueFormatter(params: ValueFormatterParams): string {
          return params.data.bankIdentificationCode.toString().replace(/\B(?=(\d{4})+(?!\d))/g, ' ')
        }
      },
      {
        flex: 1,
        minWidth: 70,
        headerName: this.$t('boarderDetailDialog.creditTabLabel').toString(),
        suppressMenu: hideDetails,
        filter: false,
        valueGetter(params: ValueGetterParams): string {
          return `${params.data.person.wallets[0].currentBalance.toFixed(2)} €`
        }
      },
    ]
  }

  updateColumnVisibility(): void {
    let hideColumn = false

    if (screen.orientation.type.includes('portrait') && ['xs', 'sm'].includes(this.$vuetify.breakpoint.name as string)) {
      hideColumn = true
    }

    if (columnApi) {
      columnApi.setColumnVisible('customers', !hideColumn)
    }
  }

  onOrientationChange() {
    setTimeout(this.updateColumnVisibility, 250)
  }

  onGridReady(params: GridOptions) {
    gridApi = params.api
    columnApi = params.columnApi
  }

  onAddBoarderButtonClick(): void {
    this.showAddBoarderDialog = true
  }

  onBoarderDetailEvent(params: RowClickedEvent): void {
    this.currentBoarder = params.data
    this.showBoarderDetailDialog = true
  }

  onAddBoarderDialogClose(): void {
    this.showAddBoarderDialog = false
    this.fetchData()
  }

  onBoarderDialogClose(isCreditDataChanged: boolean): void {
    this.currentBoarder = null
    this.showBoarderDetailDialog = false
    if(isCreditDataChanged) {
      this.fetchData()
    }
  }

  onArchiveDialogClose(operationConcluded: boolean): void {
    this.showArchiveDialog = false

    if (operationConcluded) {
      gridApi?.deselectAll()
      this.fetchData()
    }
  }

  onMoveToGroupDialogClose(operationConcluded: boolean): void {
    this.showMoveToGroupDialog = false

    if (operationConcluded) {
      gridApi?.deselectAll()
      this.fetchData()
    }
  }

  onOptOutStepperClose(): void {
    this.showOptOutStepper = false
  }

  onOptInDialogClose(): void {
    this.showOptInDialog = false
  }

  onSelectionChange(params: GridOptions): void {
    this.currentSelection = params.api!.getSelectedRows()
  }

  onOptOutButtonClick(): void {
    this.showOptOutStepper = true
  }

  onOptInButtonClick(): void {
    this.showOptInDialog = true
  }

  onArchiveButtonClick(): void {
    this.showArchiveDialog = true
  }

  onMoveToGroupButtonClick(): void {
    this.showMoveToGroupDialog = true
  }

  onNewBoarderCrated(boarder: BoarderResponse): void {
    console.debug(boarder) // TODO: spracovat
    this.showAddBoarderDialog = false
    this.fetchData()
  }

  onSendEmailButtonClick (): void {
    this.showSendEmailDialog = true
  }

  onSendEmailDialogClose (): void {
    this.showSendEmailDialog = false
  }

  onImportAttendanceDialogClose (): void {
    this.showImportAttendanceDialog = false
  }

  onResize () {
    if(this.$refs.agGrid) {
      const vw = this.$refs.agGrid.clientWidth
      this.cardWidth = vw
    }
  }

  onQrCodeDialogClose () {
    this.showQrPrintDialog = false
  }

  onPrintQrCodesButtonClick() {
    this.showQrPrintDialog = true
    /*this.qrDownloadInProgress = true
    await this.$store.dispatch(BOARDER_DOWNLOAD_QR_FILE, this.currentSelection)
    this.qrDownloadInProgress = false*/
  }

  onImportAttendanceButtonClick(): void {
    this.showImportAttendanceDialog = true
  }

  beforeMount() {
    this.gridOptions = {
      rowSelection: 'multiple',
        rowDeselection: true,
        rowMultiSelectWithClick: false,
        suppressContextMenu: true,

        defaultColDef: {
        sortable: true,

          filter: 'agTextColumnFilter',

          filterParams: {
          debounceMs: 250,
            textFormatter: (value: string) => value.toString().normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
        },

        floatingFilter: true,
          floatingFilterComponentParams: {
          suppressFilterButton: true
        }
      },

      statusBar: {
        statusPanels: [
          { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
        ],
      },

      getRowClass(params: RowNode): string {
        return params.data.status.name === 'inactive' ? 'row-inactive' : ''
      }
    }

    this.columnDefs = this.createColDefs()
    screen.orientation.addEventListener('change', this.onOrientationChange)
  }

  created () {
    this.localeTextFunc = (key: string, defaultValue: string) => {
      const tKey = `agGrid.${key}`
      const translated = this.$t(tKey)
      if(tKey === translated){
        return defaultValue
      } else {
        return translated
      }

    }
  }

  mounted() {
    this.fetchData()
  }

  updated () {
    this.onResize()
  }

  beforeDestroy() {
    screen.orientation.removeEventListener('change', this.onOrientationChange)
  }
}

</script>

<style lang="stylus" scoped>
>>> .row-inactive
  background-color silver

>>> .ag-text-field-input
  height 25px

.sloader
  width 100%

.v-slide-group
  >>> .v-slide-group__prev
    min-width 21px
    max-width 21px

  >>> .v-slide-group__next
    min-width 21px
    max-width 21px

.v-toolbar
  >>> .v-toolbar__content
    padding 0
</style>
